import createIcon from '../../createIcon';

/**
 * @component @name KeyboardControlKey
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxNC43OTQ5TDYuNDEgMTYuMjA0OUwxMiAxMC42MjQ5TDE3LjU5IDE2LjIwNDlMMTkgMTQuNzk0OUwxMiA3Ljc5NDkyTDUgMTQuNzk0OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardControlKey = createIcon('KeyboardControlKey', [
  [
    'path',
    {
      d: 'M5 14.7949L6.41 16.2049L12 10.6249L17.59 16.2049L19 14.7949L12 7.79492L5 14.7949Z',
      key: 'bujplw',
    },
  ],
]);

export default KeyboardControlKey;
